import SummaryMetrics from "../../../../components/Reports/SummaryMetrics";
import { PnlBreakdown } from "reports/getters/pnlBreakdownGetter/pnlBreakdownTypes";
import {
  getAverageRate,
  getAverageRunRate,
  useSummaryMetrics,
} from "reports/utils/metricUtils";
import { MetricEnum } from "reports/utils/metricTypes";
import { ReportParams } from "reports/types";
import { useParams } from "react-router";
import { useReportConfig } from "components/DataGetter/FlightConfig/useFlightConfig";

export default function NWSummaryMetrics({
  data,
  processGroupName,
}: {
  data: PnlBreakdown;
  processGroupName?: string;
}) {
  const reportConfig = useReportConfig();
  const { ckey: tenant } = useParams() as ReportParams;
  const configMetricsRow1 =
    reportConfig?.eosReportMetricsConfig?.summaryMetricsRow1?.map(metric => ({
      ...metric,
      ...(metric.title === "Average Rate"
        ? { customValue: getAverageRate(data) }
        : metric.title === "Average Run Rate"
          ? { customValue: getAverageRunRate(data) }
          : {}),
    }));
  const summaryMetricsRow1 = useSummaryMetrics({
    metrics: configMetricsRow1 ?? [
      ...(processGroupName !== "Coating" ? [{ name: MetricEnum.OEE }] : []),
      { name: MetricEnum.PERF },
      { name: MetricEnum.AVAIL },
      { name: MetricEnum.TAGGING },
      ...(processGroupName !== "Coating"
        ? [
            {
              name: MetricEnum.GROSS_COUNT,
              title: "Average Rate",
              customValue: getAverageRate(data),
              unit: "Parts / hour",
            },
          ]
        : []),
      ...(processGroupName !== "Coating"
        ? [
            {
              name: MetricEnum.GROSS_COUNT,
              title: "Average Run Rate",
              customValue: getAverageRunRate(data),
              unit: "Parts / hour",
            },
          ]
        : []),
    ],
    pnlBreakdown: data,
  });

  const summaryMetricsRow2 = useSummaryMetrics({
    metrics: reportConfig?.eosReportMetricsConfig?.summaryMetricsRow2 ?? [
      { name: MetricEnum.PRODUCTION_TIME },
      { name: MetricEnum.PRODUCING_TIME },
      ...(processGroupName !== "Coating" && tenant === "natureswaytwo"
        ? [{ name: MetricEnum.COUNT }]
        : []),
    ],
    pnlBreakdown: data,
  });

  return (
    <SummaryMetrics
      processGroupName={processGroupName}
      summaryMetrics={[summaryMetricsRow1, summaryMetricsRow2]}
    />
  );
}
